/**
 * 获取任务名称
 */
export const TRACK_EVENT_GET_TASK_NAME = '获取任务名称';

/**
 * 设置任务名称
 */
export const TRACK_EVENT_SET_TASK_NAME = '设置任务名称';

/**
 * 预览和导出
 */
export const TRACK_EVENT_PREVIEW_AND_EXPORT = '预览和导出';

/**
 * 进入翻译初始界面
 */
export const TRACK_EVENT_ENTER_TRANSLATION_INITIAL = '进入翻译初始界面';

/**
 * 离开翻译初始界面
 */
export const TRACK_EVENT_LEAVE_TRANSLATION_INITIAL = '离开翻译初始界面';

/**
 * 进入翻译结果界面
 */
export const TRACK_EVENT_ENTER_TRANSLATION_RESULT = '进入翻译结果界面';

/**
 * 离开翻译结果界面
 */
export const TRACK_EVENT_LEAVE_TRANSLATION_RESULT = '离开翻译结果界面';

/**
 * 进入翻译预览界面
 */
export const TRACK_EVENT_ENTER_TRANSLATION_PREVIEW = '进入翻译预览界面';

/**
 * 离开翻译预览界面
 */
export const TRACK_EVENT_LEAVE_TRANSLATION_PREVIEW = '离开翻译预览界面';

/**
 * 进入翻译导出界面
 */
export const TRACK_EVENT_ENTER_TRANSLATION_EXPORT = '进入翻译导出步骤';

/**
 * 获取推荐词
 */
export const TRACK_EVENT_GET_RECOMMEND_TRANSLATE_KEYWORD = '获取推荐词';

/**
 * 获取推荐词失败
 */
export const TRACK_EVENT_GET_RECOMMEND_TRANSLATE_KEYWORD_FAILED = '获取推荐词失败';

/**
 * 访问首页
 */
export const TRACK_EVENT_ENTER_HOME = 'homepage_view';

/**
 * 点击首页Banner (还未实现)
 */
export const TRACK_EVENT_CLICK_HOME_BANNER = 'homepage_banner_click';

/**
 * 首页OAR创建任务
 */
export const TRACK_EVENT_CREATE_OAR_HOME = 'homepage_oar_create';

/**
 * 首页说明书创建任务
 */
export const TRACK_EVENT_CREATE_SPECIFICATION_HOME = 'homepage_specification_create';

/**
 * 首页交底书创建任务
 */
export const TRACK_EVENT_CREATE_DISCLOSURE_HOME = 'homepage_disclosure_create';

/**
 * 首页翻译创建任务
 */
export const TRACK_EVENT_CREATE_TRANSLATION_HOME = 'homepage_translation_create';

/**
 * 首页查新预告
 */
export const TRACK_EVENT_CREATE_NOVELTY_FORECAST_HOME = 'homepage_novelty_forecast_click';

/**
 * 首页用户建议
 */
export const TRACK_EVENT_USER_SUGGESTION_HOME = 'homepage_user_suggestion_click';

/**
 * 首页查看近期工作 (不知道怎么实现)
 */
export const TRACK_EVENT_VIEW_RECENT_WORK_HOME = 'homepage_view_recent_work_click';

/**
 * 首页近期工作全部 (还没实现)
 */
export const TRACK_EVENT_VIEW_RECENT_WORK_ALL_HOME = 'homepage_recent_work_all_click';

/**
 * 侧边栏翻译创建任务
 */
export const TRACK_EVENT_CREATE_TRANSLATION_SIDEBAR = 'sidebar_translation_create';

/**
 * 侧边栏交底书创建任务
 */
export const TRACK_EVENT_CREATE_DISCLOSURE_SIDEBAR = 'sidebar_disclosure_create';

/**
 * 侧边栏说明书创建任务
 */
export const TRACK_EVENT_CREATE_SPECIFICATION_SIDEBAR = 'sidebar_specification_create';

/**
 * 侧边栏查新预告
 */
export const TRACK_EVENT_CREATE_NOVELTY_FORECAST_SIDEBAR = 'sidebar_novelty_forecast_click';

/**
 * 侧边栏近期工作
 */
export const TRACK_EVENT_VIEW_RECENT_WORK_SIDEBAR = 'sidebar_recent_work_click';

/**
 * 侧边栏近期工作全部
 */
export const TRACK_EVENT_VIEW_RECENT_WORK_ALL_SIDEBAR = 'sidebar_recent_work_all_click';

/**
 * 侧边栏积分点击 （未实现）
 */
export const TRACK_EVENT_VIEW_CREDITS_SIDEBAR = 'sidebar_credits_click';

/**
 * 侧边栏通知（未实现）
 */
export const TRACK_EVENT_VIEW_NOTIFICATION_SIDEBAR = 'sidebar_notification_click';

/**
 * 侧边栏设置 （未实现）
 */
export const TRACK_EVENT_VIEW_SETTINGS_SIDEBAR = 'sidebar_settings_click';

/**
 * 侧边栏设置组织 （未实现）
 */
export const TRACK_EVENT_VIEW_SETTINGS_ORGANIZATION_SIDEBAR = 'settings_organization_click';

/**
 * 侧边栏设置账号 （未实现）
 */
export const TRACK_EVENT_VIEW_SETTINGS_ACCOUNT_SIDEBAR = 'settings_account_click';

/**
 * 侧边栏设置团队 （未实现）
 */
export const TRACK_EVENT_VIEW_SETTINGS_TEAM_SIDEBAR = 'settings_team_click';

/**
 * 侧边栏设置任务 （未实现）
 */
export const TRACK_EVENT_VIEW_SETTINGS_TASKS_SIDEBAR = 'settings_tasks_click';

/**
 * 侧边栏设置语言 （未实现）
 */
export const TRACK_EVENT_VIEW_SETTINGS_LANGUAGE_SIDEBAR = 'settings_language_click';

/**
 * 侧边栏设置登出 （未实现）
 */
export const TRACK_EVENT_VIEW_SETTINGS_LOGOUT_SIDEBAR = 'settings_logout_click';

/**
 * 任务 说明书tab
 */
export const TRACK_EVENT_TASK_SPECIFICATION_TAB_CLICK = 'task_specification_tab_click';

/**
 * 任务 交底书tab
 */
export const TRACK_EVENT_TASK_DISCLOSURE_TAB_CLICK = 'task_disclosure_tab_click';

/**
 * 任务 翻译tab
 */
export const TRACK_EVENT_TASK_TRANSLATION_TAB_CLICK = 'task_translation_tab_click';

/**
 * 任务 查看
 */
export const TRACK_EVENT_TASK_VIEW_DETAIL_CLICK = 'task_view_detail_click';

/**
 * 任务 下载
 */
export const TRACK_EVENT_TASK_DOWNLOAD_CLICK = 'translation_download_click';

/**
 * 翻译 打开术语表
 */
export const TRACK_EVENT_TRANSLATION_GLOSSARY_CLICK = 'translation_glossary_click';

/**
 * 翻译 新增术语
 */
export const TRACK_EVENT_TRANSLATION_GLOSSARY_ADD_CLICK = 'translation_glossary_add_click';

/**
 * 翻译 导入术语
 */
export const TRACK_EVENT_TRANSLATION_GLOSSARY_IMPORT_CLICK = 'translation_glossary_import_click';

/**
 * 翻译 编辑术语 (无法实现)
 */
export const TRACK_EVENT_TRANSLATION_GLOSSARY_EDIT_CLICK = 'translation_glossary_edit_click';

/**
 * 翻译 删除术语
 */
export const TRACK_EVENT_TRANSLATION_GLOSSARY_DELETE_CLICK = 'translation_glossary_delete_click';

/**
 * 翻译 保存术语
 */
export const TRACK_EVENT_TRANSLATION_GLOSSARY_SUBMIT_CLICK = 'translation_glossary_submit_click';

/**
 * 翻译 选择样例
 */
export const TRACK_EVENT_TRANSLATION_SELECT_SAMPLE_CLICK = 'translation_select_sample_click';

/**
 * 翻译 选择语言
 */
export const TRACK_EVENT_TRANSLATION_SELECT_LANGUAGE = 'translation_select_language';

/**
 * 翻译 开始翻译
 */
export const TRACK_EVENT_TRANSLATION_START_CLICK = 'translation_start_click';

/**
 * 翻译 修改标题 (通用编辑头)
 */
export const TRACK_EVENT_EDIT_TITLE = 'translation_edit_title';

/**
 * 翻译 修改原文重译
 */
export const TRACK_EVENT_TRANSLATION_RETRANSLATE_ORIGINAL_CLICK = 'translation_retranslate_original_click';

/**
 * 翻译 编辑译文
 */
export const TRACK_EVENT_TRANSLATION_EDIT_TRANSLATION_CLICK = 'translation_edit_translation_click';

/**
 * 翻译 译文重译
 */
export const TRACK_EVENT_TRANSLATION_RETRANSLATE_TRANSLATION_CLICK = 'translation_retranslate_translation_click';

/**
 * 翻译 创建新任务
 */
export const TRACK_EVENT_TRANSLATION_START_NEW_TASK_CLICK = 'translation_start_new_task_click';

/**
 * 翻译 预览全文
 */
export const TRACK_EVENT_TRANSLATION_PREVIEW_CLICK = 'translation_preview_click';

/**
 * 翻译 导出全文
 */
export const TRACK_EVENT_TRANSLATION_EXPORT_CLICK = 'translation_export_click';

/**
 * 交底书 选择样例
 */
export const TRACK_EVENT_DISCLOSURE_SELECT_SAMPLE_CLICK = 'disclosure_select_sample_click';

/**
 * 交底书 开始生成
 */
export const TRACK_EVENT_DISCLOSURE_GENERATE_CLICK = 'disclosure_generate_click';

/**
 * 交底书 编辑要素 重新生成
 */
export const TRACK_EVENT_DISCLOSURE_EDIT_INTERPRETATION_CLICK = 'disclosure_edit_interpretation_click';

/**
 * 交底书 查看引用 （未实现）
 */
export const TRACK_EVENT_DISCLOSURE_VIEW_REFERENCES_CLICK = 'disclosure_view_references_click';

/**
 * 交底书 编辑保存
 */
export const TRACK_EVENT_DISCLOSURE_EDIT_SUBMIT_CLICK = 'disclosure_edit_submit_click';

/**
 * 交底书 AI优化 (未实现)
 */
export const TRACK_EVENT_DISCLOSURE_AI_OPTIMIZE_CLICK = 'disclosure_ai_optimize_click';

/**
 * 交底书 导出全文
 */
export const TRACK_EVENT_DISCLOSURE_EXPORT_CLICK = 'disclosure_export_click';

/**
 * 交底书 创建新任务
 */
export const TRACK_EVENT_DISCLOSURE_START_NEW_TASK_CLICK = 'disclosure_start_new_task_click';

/**
 * 侧边点击事件
 */
export const TRACK_EVENT_CREATE_AGENT_SIDEBAR = 'sidebar_create_agent_click';

/**
 * 说明书
 * @description 说明书首页
 */
export const TRACK_EVENT_SPECIFICATION_HOMEPAGE_VIEW = 'specification_homepage_view';

/**
 * 说明书
 * @description 样例使用人数，需要传入当前点击的样例类型
 */
export const TRACK_EVENT_SPECIFICATION_HOMEPAGE_SAMPLE = 'specification_homepage_sample';

/**
 * 说明书
 * @description 创建页面的生成按钮
 */
export const TRACK_EVENT_SPECIFICATION_HOMEPAGE_GENERATE = 'specification_homepage_generate';

/**
 * 说明书
 * @description 美国专利说明书生成
 */
export const TRACK_EVENT_SPECIFICATION_US_GENERATE = 'specification_us_generate';

/**
 * 说明书
 * @description 中国专利说明书生成
 */
export const TRACK_EVENT_SPECIFICATION_CN_GENERATE = 'specification_cn_generate';

/**
 * 说明书
 * @description 欧洲专利说明书生成
 */
export const TRACK_EVENT_SPECIFICATION_EU_GENERATE = 'specification_eu_generate';

/**
 * 说明书
 * @description 确认交底书的重新生成
 */
export const TRACK_EVENT_SPECIFICATION_DISCLOSURE_REGENERATE = 'specification_disclosure_regenerate';

/**
 * 说明书
 * @description 进入权要界面次数，确认交底书的下一步按钮
 */
export const TRACK_EVENT_SPECIFICATION_DISCLOSURE_GENERATE = 'specification_disclosure_generate';

/**
 * 说明书
 * @description 确认权利要求的重新生成
 */
export const TRACK_EVENT_SPECIFICATION_CLAIMS_REGENERATE = 'specification_claims_regenerate';

/**
 * 说明书
 * @description 权利要求操作，编辑、拖动权利要求，增删改拖动权利要求的特征短语
 */
export const TRACK_EVENT_SPECIFICATION_CLAIMS_FEATURES = 'specification_claims_features';

/**
 * 说明书
 * @description 术语调整操作，新增、删除术语
 */
export const TRACK_EVENT_SPECIFICATION_CLAIMS_TERMS = 'specification_claims_terms';

/**
 * 说明书
 * @description 正式生成，确认权利要求的生成按钮
 */
export const TRACK_EVENT_SPECIFICATION_CLAIMS_GENERATE = 'specification_claims_generate';

/**
 * 说明书
 * @description 生成页面，手动停止生成
 * @description 需要传参当前处理的段落
 */
export const TRACK_EVENT_SPECIFICATION_GENERATION_STOP = 'specification_generation_stop';

/**
 * 说明书
 * @description 生成页面，生成失败和手动停止时的重新生成按钮
 */
export const TRACK_EVENT_SPECIFICATION_GENERATION_REGENERATE = 'specification_generation_regenerate';

/**
 * 说明书
 * @description 优化
 * @description 需要传参当前处理的段落
 */
export const TRACK_EVENT_SPECIFICATION_GENERATION_REWRITE = 'specification_generation_rewrite';

/**
 * 说明书
 * @description 扩写
 * @description 需要传参当前处理的段落
 */
export const TRACK_EVENT_SPECIFICATION_GENERATION_LONGER = 'specification_generation_longer';

/**
 * 说明书
 * @description 缩写
 * @description 需要传参当前处理的段落
 */
export const TRACK_EVENT_SPECIFICATION_GENERATION_SHORTER = 'specification_generation_shorter';

/**
 * 说明书
 * @description 续写、扩展实施例
 * @description 需要传参当前处理的段落
 */
export const TRACK_EVENT_SPECIFICATION_GENERATION_EXPAND = 'specification_generation_expand';

/**
 * 免费版使用量超限弹出. 从eureka中copy过来的的事件名字
 */
export const AIR_USAGE_UPGRADE_SHOW = 'AIR-usage-upgrade-show';

/**
 * 说明书
 * @description 导出次数
 */
export const TRACK_EVENT_SPECIFICATION_GENERATION_EXPORT = 'specification_generation_export';

/**
 * 说明书
 * @description 生成页 AI 助手调整内容弹窗的重新生成
 */
export const TRACK_EVENT_SPECIFICATION_MODIFY_REGENERATE = 'specification_modify_regenerate';


/**
 * 用户在首页“撰写”模块点击了“上传交底书”按钮
 */
export const TRACK_EVENT_SPECIFICATION_DISCLOSURE_UPLOAD = 'specification_disclosure_upload';

/**
 * 用户在首页“撰写”模块点击了“上传权利要求”按钮
 */
export const TRACK_EVENT_SPECIFICATION_CLAIMS_UPLOAD = 'specification_claims_upload';

/**
 * 查新
 * @description 记录进入功能的动作，通过 user_id 聚合分析用户数、频次
 */
export const TRACK_EVENT_NOVELTY_CHECK_ENTER = 'enter_novelty_check';

/**
 * 查新
 * @description 用户在任何输入框开始输入内容时触发
 */
export const TRACK_EVENT_NOVELTY_CHECK_USER_INPUT = 'user_input';

/**
 * 查新
 * @description 用户成功上传文档到系统时记录 (还未实现)
 */
export const TRACK_EVENT_NOVELTY_CHECK_UPLOAD_DOCUMENT = 'upload_document';

/**
 * 查新
 * @description 用户从样例库中选择特定样例时触发
 */
export const TRACK_EVENT_NOVELTY_CHECK_SELECT_EXAMPLE = 'select_example';

/**
 * 查新
 * @description 用户点击开始查新按钮，启动查新流程
 */
export const TRACK_EVENT_NOVELTY_CHECK_LAUNCH = 'launch_novelty_check';

/**
 * 查新
 * @description 用户点击打开 Memory 抽屉时触发
 */
export const TRACK_EVENT_NOVELTY_CHECK_CLICK_MEMORY = 'click_memory';

/**
 * 查新
 * @description 系统在语言检查过程中发现错误或不符合规范的内容时记录 (还未实现)
 */
export const TRACK_EVENT_NOVELTY_CHECK_LAUNCH_ERROR = 'lang_check_error';

/**
 * 查新
 * @description 用户主动中止技术特征识别流程时触发
 */
export const TRACK_EVENT_NOVELTY_CHECK_ABORT_TECH_FEATURE = 'abort_tech_feature';

/**
 * 查新
 * @description 用户确认系统识别的技术特征无误时记录
 */
export const TRACK_EVENT_NOVELTY_CHECK_CONFIRM_TECH_FEATURE = 'confirm_tech_feature';

/**
 * 查新
 * @description 用户提前终止深度思考过程并生成报告时触发
 */
export const TRACK_EVENT_NOVELTY_CHECK_DEEP_THINKING_STOP = 'deep_thinking_stop';

/**
 * 查新
 * @description 用户通过输入专利号手动添加对比文献时记录
 */
export const TRACK_EVENT_NOVELTY_CHECK_ADD_REF_PATENT = 'add_ref_patent';

/**
 * 查新
 * @description 保存到工作空间
 */
export const TRACK_EVENT_NOVELTY_CHECK_SAVE_TO_WORKSPACE = 'save_to_workspace';

/**
 * 查新
 * @description 成功保存到工作空间
 */
export const TRACK_EVENT_NOVELTY_CHECK_SAVE_TO_WORKSPACE_SUCCESS = 'save_to_workspace_success';

/**
 * 查新
 * @description 特征对比返回
 */
export const TRACK_EVENT_NOVELTY_CHECK_COMPARE_TABLE_BACK = 'compare_table_back';

/**
 * 查新
 * @description 用户在检索结果列表中点击查看特定专利的详细信息时触发
 */
export const TRACK_EVENT_NOVELTY_CHECK_VIEW_PATENT_DETAIL = 'view_patent_detail';

/**
 * 查新
 * @description 用户在技术特征对比表中点击搜索公知证据按钮
 */
export const TRACK_EVENT_NOVELTY_CHECK_SEARCH_COMMON_EVIDENCE = 'search_common_evidence';

/**
 * 查新
 * @description 用户切换技术特征对比表中"显示公知证据"开关
 */
export const TRACK_EVENT_NOVELTY_CHECK_TOGGLE_COMMON_EVIDENCE = 'toggle_common_evidence';

/**
 * 查新
 * @description 用户点击加载更多检索结果时记录
 */
export const TRACK_EVENT_NOVELTY_CHECK_SHOW_MORE_RESULTS = 'show_more_results';

/**
 * 查新
 * @description 用户从检索结果中选择文献作为对比文献时触发
 */
export const TRACK_EVENT_NOVELTY_CHECK_SEARCH_RESULT_SELECT = 'search_result_select';

/**
 * 查新
 * @description 用户对对比文献列表进行编辑操作（如删除、排序）时记录 (还未实现)
 */
export const TRACK_EVENT_NOVELTY_CHECK_COMPARISON_LIST_EDIT = 'comparisonlist_edit';

/**
 * 查新
 * @description 用户点击生成查新报告并成功创建时触发
 */
export const TRACK_EVENT_NOVELTY_CHECK_CREATE_REPORT = 'create_report';

/**
 * 查新
 * @description 用户点击展开“展开 Agent 过程”
 */
export const TRACK_EVENT_NOVELTY_CHECK_REPORT_EXPAND = 'noveltyreport_expand';

/**
 * 查新
 * @description 用户点击编辑技术方案
 */
export const TRACK_EVENT_NOVELTY_CHECK_REPORT_EDIT_TECH_PROPOSAL = 'noveltyreport_edit_tech_proposal';

/**
 * 查新
 * @description 用户取消选择技术特征
 */
export const TRACK_EVENT_NOVELTY_CHECK_REPORT_UNSELECT_FEATURE = 'noveltyreport_unselect_feature';

/**
 * 查新
 * @description 用户新增技术特征
 */
export const TRACK_EVENT_NOVELTY_CHECK_REPORT_ADD_FEATURE = 'noveltyreport_add_feature';

/**
 * 查新
 * @description 添加、删除关键词、关键词组、分类号、检索要素
 */
export const TRACK_EVENT_NOVELTY_CHECK_REPORT_UPDATE_RETRIEVAL_ELEMENTS = 'noveltyreport_update_retrieval_elements';

/**
 * 查新
 * @description 同组合并
 */
export const TRACK_EVENT_NOVELTY_CHECK_REPORT_FAMILY_GROUP = 'noveltyreport_family_group';

/**
 * 查新
 * @description 老设置入口变更设置时触发，用于判断设置入口使用情况
 */
export const TRACK_EVENT_NOVELTY_CHECK_REPORT_SETTING_CHANGE = 'noveltyreport_setting_change';

/**
 * 查新
 * @description 用户将查新报告导出为指定格式（如PDF/DOC）时触发 (还未实现)
 */
export const TRACK_EVENT_NOVELTY_CHECK_REPORT_EXPORT = 'novelty_report_export';

/**
 * 查新
 * @description 切换到saas查新
 */
export const TRACK_EVENT_NOVELTY_CHECK_REPORT_SELECT_OLD_VERSION = 'select_old_novelty';
/**
 * 查新
 * @description 切换到数字人查新
 */
export const TRACK_EVENT_NOVELTY_CHECK_REPORT_SELECT_NEW_VERSION = 'select_new_novelty';

/**
 * 防侵权检索
 * @description 记录进入功能的动作，通过 user_id 聚合分析用户数、频次
 */
export const TRACK_EVENT_FTO_REPORT_ENTER = 'enter_fto';

/**
 * 防侵权检索
 * @description 用户选择或修改 受理局、简单法律状态、仅包含企业、排除企业、开始时间 过滤项
 */
export const TRACK_EVENT_FTO_REPORT_SET_ADVANCED_SETTINGS = 'set_advanced_settings';

/**
 * 防侵权检索
 * @description 用户在任何输入框开始输入内容时触发
 */
export const TRACK_EVENT_FTO_REPORT_USER_INPUT = 'input_tech_solution';

/**
 * 防侵权检索
 * @description 用户从样例库中选择特定样例时触发（产品未要求）
 */
export const TRACK_EVENT_FTO_REPORT_SELECT_EXAMPLE = 'fto_report_select_example';

/**
 * 防侵权检索
 * @description 用户点击开始查新按钮，启动FTO流程
 */
export const TRACK_EVENT_FTO_REPORT_LAUNCH = 'launch_fto_agent';

/**
 * 防侵权检索
 * @description 用户在输入页点击“开始”
 */
export const TRACK_EVENT_FTO_REPORT_INPUT_SUBMIT = 'input_submit';

/**
 * 防侵权检索
 * @description 用户主动中止技术特征识别流程时触发（产品未要求）
 */
export const TRACK_EVENT_FTO_REPORT_ABORT_TECH_FEATURE = 'fto_report_abort_tech_feature';

/**
 * 防侵权检索
 * @description 用户新增、修改技术特征，或修改技术方案
 */
export const TRACK_EVENT_FTO_REPORT_EDIT_TECH_FEATURE = 'edit_tech_feature';

/**
 * 防侵权检索
 * @description 用户确认系统识别的技术特征无误时记录
 */
export const TRACK_EVENT_FTO_REPORT_CONFIRM_TECH_FEATURE = 'confirm_tech_feature';

/**
 * 防侵权检索
 * @description 用户提前终止深度思考过程并生成报告时触发（产品未要求）
 */
export const TRACK_EVENT_FTO_REPORT_DEEP_THINKING_STOP = 'fto_report_deep_thinking_stop';

/**
 * 防侵权检索
 * @description 用户查看技术特征与对比文献的比较结果。
 */
export const TRACK_EVENT_FTO_REPORT_VIEW_TECH_COMPARE = 'view_tech_compare';

/**
 * 防侵权检索
 * @description 用户点击添加专利按钮
 */
export const TRACK_EVENT_FTO_REPORT_ADD_PATENT = 'click_add_patent';

/**
 * 防侵权检索
 * @description 用户通过输入专利号手动添加对比文献时记录
 */
export const TRACK_EVENT_FTO_REPORT_ADD_REF_PATENT = 'add_reference';

/**
 * 防侵权检索
 * @description 用户编辑技术特征对比表格。
 */
export const TRACK_EVENT_FTO_REPORT_EDIT_FEATURE_TABLE = 'edit_feature_table';

/**
 * 防侵权检索
 * @description 用户在检索结果列表中点击查看特定专利的详细信息时触发（产品未要求）
 */
export const TRACK_EVENT_FTO_REPORT_VIEW_PATENT_DETAIL = 'fto_report_view_patent_detail';

/**
 * 防侵权检索
 * @description 用户点击加载更多检索结果时记录（产品未要求）
 */
export const TRACK_EVENT_FTO_REPORT_SHOW_MORE_RESULTS = 'fto_report_show_more_results';

/**
 * 防侵权检索
 * @description 用户从检索结果中选择文献作为对比文献时触发
 */
export const TRACK_EVENT_FTO_REPORT_SEARCH_RESULT_SELECT = 'select_related_patent';

/**
 * 防侵权检索
 * @description 用户点击生成FTO报告并成功创建时触发
 */
export const TRACK_EVENT_FTO_REPORT_CREATE_REPORT = 'create_fto_report';

/**
 * 防侵权检索
 * @description 用户点击展开“展开 Agent 过程”（产品未要求）
 */
export const TRACK_EVENT_FTO_REPORT_REPORT_EXPAND = 'fto_report_report_expand';

/**
 * 防侵权检索
 * @description 用户将FTO报告导出为指定格式（如PDF/DOC）时触发
 */
export const TRACK_EVENT_FTO_REPORT_REPORT_EXPORT = 'export_fto_report';

/**
 * 防侵权检索
 * @description 用户创建新的 FTO 任务。
 */
export const TRACK_EVENT_FTO_REPORT_CREATE_NEW_TASK = 'create_new_fto_task';

/**
 * 防侵权检索
 * @description AI 成功生成方案并加载确认页
 */
export const TRACK_EVENT_FTO_REPORT_PROPOSAL_GENERATED = 'proposal_generated';

/**
 * 防侵权检索
 * @description 用户在特征提取确认页对表格进行操作
 */
export const TRACK_EVENT_FTO_REPORT_FEATURE_CONFIRM_ACTION = 'feature_confirm_action';

/**
 * 防侵权检索
 * @description 统计用户修改技术特征的频次，评估 AI 特征提取的准确性。
 */
export const TRACK_EVENT_FTO_REPORT_FEATURE_EDIT_ACTION = 'feature_edit_action';

/**
 * 防侵权检索
 * @description 用户点击“确认并运行”
 */
export const TRACK_EVENT_FTO_REPORT_CONFIRM_RUN = 'confirm_run';

/**
 * 防侵权检索
 * @description 用户点击“保存并运行”
 */
export const TRACK_EVENT_FTO_REPORT_EDIT_SAVE = 'edit_save';

/**
 * 防侵权检索
 * @description 统计用户纠正 AI 分类的次数（例如 AI 说保留，用户改排除）。
 */
export const TRACK_EVENT_FTO_REPORT_PATENT_RECLASSIFY = 'patent_reclassify';

/**
 * 防侵权检索
 * @description 统计用户点击编辑按钮
 */
export const TRACK_EVENT_FTO_REPORT_EDIT = 'click_edit';

/**
 * 防侵权检索
 * @description 统计用户点击从工作空间导入
 */
export const TRACK_EVENT_FTO_REPORT_IMPORT_FROM_WORKSPACE = 'click_import_from_workspace';

/**
 * 用户在首页点击了“体验更多Agent”的入口（按钮/链接）I. I.
 */
export const TRACK_EVENT_HOMEPAGE_MORE_AGENTS_TOGGLE = 'homepage_more_agents_toggle';
/**
 * 用户在“更多Agent”页点击了“其他Agent”入口
 */
export const TRACK_EVENT_HOMEPAGE_MORE_AGENTS_CLICK = 'homepage_more_agents_click';
/**
 * 用户点击 Home V2 工作中任务模块内的操作。
 */
export const TRACK_EVENT_HOMEPAGE_WORK_IN_PROGRESS_CLICK = 'homepage_work_in_progress_click';
/**
 * 用户在套餐对比页（或特定套餐页）点击了“升级Pro”按钮
 */
export const TRACK_EVENT_PLANS_UPGRADE_PRO_CLICK = 'plans_upgrade_pro_click';
/**
 * 用户在套餐对比页（或特定套餐页）点击了“联系我们”按钮
 */
export const TRACK_EVENT_PLANS_CONTACT_SALES_CLICK = 'plans_contact_sales_click';
/**
 * 用户在内嵌的Hubspot表单中点击了"确认提交"按钮
 */
export const TRACK_EVENT_HUBSPOT_FORM_SUBMIT = 'hubspot_form_submit';
/**
 * 任务分享菜单点击
 */
export const TRACK_EVENT_TASK_SHARE_MENU_CLICK = 'task_share_menu_click';
/**
 * 任务分享拷贝链接点击
 */
export const TRACK_EVENT_TASK_SHARE_COPY_LINK_CLICK = 'task_share_copy_link_click';

/**
 * 外观FTO
 * @description 记录进入外观FTO功能入口页
 */
export const TRACK_EVENT_DESIGN_FTO_ENTER = 'enter_design_fto';

/**
 * 外观FTO
 * @description 用户点击示例图片
 */
export const TRACK_EVENT_DESIGN_FTO_SELECT_EXAMPLE = 'design_fto_select_example';

/**
 * 外观FTO
 * @description 用户成功上传图片
 */
export const TRACK_EVENT_DESIGN_FTO_UPLOAD_IMAGE = 'design_fto_upload_image';

/**
 * 外观FTO
 * @description 用户点击开始检索按钮，启动外观FTO流程
 */
export const TRACK_EVENT_DESIGN_FTO_LAUNCH = 'launch_design_fto';

/**
 * 外观FTO
 * @description 记录进入外观FTO流程页面
 */
export const TRACK_EVENT_DESIGN_FTO_ENTER_FLOW = 'enter_design_fto_flow';

/**
 * 外观FTO
 * @description 用户点击专利号查看专利详情
 */
export const TRACK_EVENT_DESIGN_FTO_VIEW_PATENT_DETAIL = 'design_fto_view_patent';

/**
 * 外观FTO
 * @description 用户查看特征对比表
 */
export const TRACK_EVENT_DESIGN_FTO_VIEW_COMPARISON = 'design_fto_view_comparison';

/**
 * 外观FTO
 * @description 用户点击分享按钮
 */
export const TRACK_EVENT_DESIGN_FTO_SHARE = 'design_fto_share';

/**
 * 外观FTO
 * @description 用户复制分享链接
 */
export const TRACK_EVENT_DESIGN_FTO_COPY_LINK = 'design_fto_copy_link';

/**
 * 外观FTO
 * @description 导出报告
 */
export const TRACK_EVENT_DESIGN_FTO_EXPORT_REPORT = 'design_fto_export_report';
/**
 * 升级触发
 */
export const TRACK_EVENT_UPGRADE_TRIGGER = 'upgrade_trigger';
/**
 * 登录注册弹窗触发
 */
export const TRACK_EVENT_REGISTER_EXPOSURE = 'register_exposure';
/**
 * 用户点击"注册"
 */
export const TRACK_EVENT_REGISTER_CLICK = 'register_click';
/**
 * 用户关闭注册框
 */
export const TRACK_EVENT_REGISTER_CLOSE = 'register_close';

/**
 * 定价页面浏览
 */
export const TRACK_EVENT_PRICING_PAGE_VIEW = 'pricing_page_view';

/**
 * 点击订阅Pro
 */
export const TRACK_EVENT_CLICK_SUBSCRIBE_PRO = 'click_subscribe_pro';
export const TRACK_EVENT_CLICK_SUBSCRIBE_ENTERPRISE= 'click_subscribe_enterprise';
export const TRACK_EVENT_CLICK_SUBSCRIBE_API= 'click_subscribe_api';
export const TRACK_EVENT_DESIGN_FTO_COPY_LINK_2 = 'result_share_link';

/**
 * 外观FTO
 * @description 用户点击查看步骤结果
 */
export const TRACK_EVENT_DESIGN_FTO_VIEW_RESULT = 'result_view_button';

/** Agent 报告分享与导出入口高亮。 */
export const TRACK_EVENT_AGENT_REPORT_ACTIONS_SPOTLIGHTED = 'ip_agent_report_actions_spotlighted';

/**
 * 以上的写法逐渐废弃,使用这个SOURCE_TYPE
 */
export const SOURCE_TYPE = {
    agent_home: 'agent_home',
};

/**
 * 游客注册墙
 * @description 游客点击受限能力后弹出注册墙
 */

/**
 * 游客点击受限能力后，注册墙展示
 * 属性：agent_type、trigger_source、task_id、report_id
 */
export const TRACK_EVENT_IP_AGENT_GUEST_REGISTER_WALL_SHOWN = 'ip_agent_guest_register_wall_shown';

/**
 * 游客关闭注册墙
 * 属性：agent_type、trigger_source、task_id、report_id
 */
export const TRACK_EVENT_IP_AGENT_GUEST_REGISTER_WALL_CLOSED = 'ip_agent_guest_register_wall_closed';

/**
 * 游客在注册墙中进入注册流程（点击注册按钮）
 * 属性：agent_type、trigger_source、task_id、report_id、pending_action
 */
export const TRACK_EVENT_IP_AGENT_GUEST_REGISTER_STARTED = 'ip_agent_guest_register_started';

/**
 * 游客完成注册并回到产品
 * 属性：agent_type、trigger_source、task_id、report_id、pending_action
 */
export const TRACK_EVENT_IP_AGENT_GUEST_REGISTER_SUCCEEDED = 'ip_agent_guest_register_succeeded';

/**
 * Share、Download 或 Export 自动续接成功
 * 属性：agent_type、task_id、report_id、pending_action
 */
export const TRACK_EVENT_IP_AGENT_GUEST_PENDING_ACTION_RESUMED = 'ip_agent_guest_pending_action_resumed';

/**
 * 自动续接失败（内部排障埋点，非 Confluence 对外事件）
 * 属性：agent_type、trigger_source、task_id、report_id、pending_action、failure_reason、error_message?
 * 失败原因：missing_id / task_not_accessible / validation_error / action_handler_not_provided / action_execution_error
 */
export const TRACK_EVENT_GUEST_ACTION_RESUME_FAILED = 'guest_action_resume_failed';

/**
 * source_type 在埋点调试面板中的可读解释。
 *
 * 新增埋点时可以在这里补充说明；未配置的事件会直接展示原始 source_type。
 */
export const TRACK_EVENT_DESCRIPTIONS: Record<string, string> = {
    [TRACK_EVENT_GET_TASK_NAME]: '获取任务名称',
    [TRACK_EVENT_SET_TASK_NAME]: '设置任务名称',
    [TRACK_EVENT_PREVIEW_AND_EXPORT]: '预览和导出',
    [TRACK_EVENT_ENTER_TRANSLATION_INITIAL]: '进入翻译初始界面',
    [TRACK_EVENT_LEAVE_TRANSLATION_INITIAL]: '离开翻译初始界面',
    [TRACK_EVENT_ENTER_TRANSLATION_RESULT]: '进入翻译结果界面',
    [TRACK_EVENT_LEAVE_TRANSLATION_RESULT]: '离开翻译结果界面',
    [TRACK_EVENT_ENTER_TRANSLATION_PREVIEW]: '进入翻译预览界面',
    [TRACK_EVENT_LEAVE_TRANSLATION_PREVIEW]: '离开翻译预览界面',
    [TRACK_EVENT_ENTER_TRANSLATION_EXPORT]: '进入翻译导出步骤',
    [TRACK_EVENT_GET_RECOMMEND_TRANSLATE_KEYWORD]: '获取推荐词',
    [TRACK_EVENT_GET_RECOMMEND_TRANSLATE_KEYWORD_FAILED]: '获取推荐词失败',
    [TRACK_EVENT_ENTER_HOME]: '访问首页',
    [TRACK_EVENT_CLICK_HOME_BANNER]: '点击首页 Banner',
    [TRACK_EVENT_CREATE_OAR_HOME]: '首页创建 OAR 任务',
    [TRACK_EVENT_CREATE_SPECIFICATION_HOME]: '首页创建说明书任务',
    [TRACK_EVENT_CREATE_DISCLOSURE_HOME]: '首页创建交底书任务',
    [TRACK_EVENT_CREATE_TRANSLATION_HOME]: '首页创建翻译任务',
    [TRACK_EVENT_CREATE_NOVELTY_FORECAST_HOME]: '首页点击查新预告',
    [TRACK_EVENT_USER_SUGGESTION_HOME]: '首页用户建议',
    [TRACK_EVENT_VIEW_RECENT_WORK_HOME]: '首页查看近期工作',
    [TRACK_EVENT_VIEW_RECENT_WORK_ALL_HOME]: '首页查看全部近期工作',
    [TRACK_EVENT_CREATE_TRANSLATION_SIDEBAR]: '侧边栏创建翻译任务',
    [TRACK_EVENT_CREATE_DISCLOSURE_SIDEBAR]: '侧边栏创建交底书任务',
    [TRACK_EVENT_CREATE_SPECIFICATION_SIDEBAR]: '侧边栏创建说明书任务',
    [TRACK_EVENT_CREATE_NOVELTY_FORECAST_SIDEBAR]: '侧边栏点击查新预告',
    [TRACK_EVENT_VIEW_RECENT_WORK_SIDEBAR]: '侧边栏查看近期工作',
    [TRACK_EVENT_VIEW_RECENT_WORK_ALL_SIDEBAR]: '侧边栏查看全部近期工作',
    [TRACK_EVENT_VIEW_CREDITS_SIDEBAR]: '侧边栏点击积分',
    [TRACK_EVENT_VIEW_NOTIFICATION_SIDEBAR]: '侧边栏点击通知',
    [TRACK_EVENT_VIEW_SETTINGS_SIDEBAR]: '侧边栏点击设置',
    [TRACK_EVENT_VIEW_SETTINGS_ORGANIZATION_SIDEBAR]: '查看组织设置',
    [TRACK_EVENT_VIEW_SETTINGS_ACCOUNT_SIDEBAR]: '查看账号设置',
    [TRACK_EVENT_VIEW_SETTINGS_TEAM_SIDEBAR]: '查看团队设置',
    [TRACK_EVENT_VIEW_SETTINGS_TASKS_SIDEBAR]: '查看任务设置',
    [TRACK_EVENT_VIEW_SETTINGS_LANGUAGE_SIDEBAR]: '查看语言设置',
    [TRACK_EVENT_VIEW_SETTINGS_LOGOUT_SIDEBAR]: '侧边栏退出登录',
    [TRACK_EVENT_TASK_SPECIFICATION_TAB_CLICK]: '点击任务说明书 Tab',
    [TRACK_EVENT_TASK_DISCLOSURE_TAB_CLICK]: '点击任务交底书 Tab',
    [TRACK_EVENT_TASK_TRANSLATION_TAB_CLICK]: '点击任务翻译 Tab',
    [TRACK_EVENT_TASK_VIEW_DETAIL_CLICK]: '查看任务详情',
    [TRACK_EVENT_TASK_DOWNLOAD_CLICK]: '下载任务结果',
    [TRACK_EVENT_TRANSLATION_GLOSSARY_CLICK]: '打开术语表',
    [TRACK_EVENT_TRANSLATION_GLOSSARY_ADD_CLICK]: '新增术语',
    [TRACK_EVENT_TRANSLATION_GLOSSARY_IMPORT_CLICK]: '导入术语',
    [TRACK_EVENT_TRANSLATION_GLOSSARY_EDIT_CLICK]: '编辑术语',
    [TRACK_EVENT_TRANSLATION_GLOSSARY_DELETE_CLICK]: '删除术语',
    [TRACK_EVENT_TRANSLATION_GLOSSARY_SUBMIT_CLICK]: '保存术语',
    [TRACK_EVENT_TRANSLATION_SELECT_SAMPLE_CLICK]: '选择翻译样例',
    [TRACK_EVENT_TRANSLATION_SELECT_LANGUAGE]: '选择翻译语言',
    [TRACK_EVENT_TRANSLATION_START_CLICK]: '开始翻译',
    [TRACK_EVENT_EDIT_TITLE]: '编辑标题',
    [TRACK_EVENT_TRANSLATION_RETRANSLATE_ORIGINAL_CLICK]: '重译原文',
    [TRACK_EVENT_TRANSLATION_EDIT_TRANSLATION_CLICK]: '编辑译文',
    [TRACK_EVENT_TRANSLATION_RETRANSLATE_TRANSLATION_CLICK]: '重译译文',
    [TRACK_EVENT_TRANSLATION_START_NEW_TASK_CLICK]: '创建新的翻译任务',
    [TRACK_EVENT_TRANSLATION_PREVIEW_CLICK]: '预览翻译结果',
    [TRACK_EVENT_TRANSLATION_EXPORT_CLICK]: '导出翻译结果',
    [TRACK_EVENT_DISCLOSURE_SELECT_SAMPLE_CLICK]: '选择交底书样例',
    [TRACK_EVENT_DISCLOSURE_GENERATE_CLICK]: '开始生成交底书',
    [TRACK_EVENT_DISCLOSURE_EDIT_INTERPRETATION_CLICK]: '编辑交底书要素并重新生成',
    [TRACK_EVENT_DISCLOSURE_VIEW_REFERENCES_CLICK]: '查看交底书引用',
    [TRACK_EVENT_DISCLOSURE_EDIT_SUBMIT_CLICK]: '保存交底书编辑',
    [TRACK_EVENT_DISCLOSURE_AI_OPTIMIZE_CLICK]: 'AI 优化交底书',
    [TRACK_EVENT_DISCLOSURE_EXPORT_CLICK]: '导出交底书',
    [TRACK_EVENT_DISCLOSURE_START_NEW_TASK_CLICK]: '创建新的交底书任务',
    [TRACK_EVENT_CREATE_AGENT_SIDEBAR]: '侧边栏创建 Agent 任务',
    [TRACK_EVENT_SPECIFICATION_HOMEPAGE_VIEW]: '进入说明书首页',
    [TRACK_EVENT_SPECIFICATION_HOMEPAGE_SAMPLE]: '选择说明书样例',
    [TRACK_EVENT_SPECIFICATION_HOMEPAGE_GENERATE]: '点击说明书生成按钮',
    [TRACK_EVENT_SPECIFICATION_US_GENERATE]: '生成美国专利说明书',
    [TRACK_EVENT_SPECIFICATION_CN_GENERATE]: '生成中国专利说明书',
    [TRACK_EVENT_SPECIFICATION_EU_GENERATE]: '生成欧洲专利说明书',
    [TRACK_EVENT_SPECIFICATION_DISCLOSURE_REGENERATE]: '重新生成交底书',
    [TRACK_EVENT_SPECIFICATION_DISCLOSURE_GENERATE]: '确认交底书并进入权利要求',
    [TRACK_EVENT_SPECIFICATION_CLAIMS_REGENERATE]: '重新生成权利要求',
    [TRACK_EVENT_SPECIFICATION_CLAIMS_FEATURES]: '编辑权利要求特征',
    [TRACK_EVENT_SPECIFICATION_CLAIMS_TERMS]: '调整权利要求术语',
    [TRACK_EVENT_SPECIFICATION_CLAIMS_GENERATE]: '确认生成权利要求',
    [TRACK_EVENT_SPECIFICATION_GENERATION_STOP]: '停止说明书生成',
    [TRACK_EVENT_SPECIFICATION_GENERATION_REGENERATE]: '重新生成说明书内容',
    [TRACK_EVENT_SPECIFICATION_GENERATION_REWRITE]: '优化说明书段落',
    [TRACK_EVENT_SPECIFICATION_GENERATION_LONGER]: '扩写说明书段落',
    [TRACK_EVENT_SPECIFICATION_GENERATION_SHORTER]: '缩写说明书段落',
    [TRACK_EVENT_SPECIFICATION_GENERATION_EXPAND]: '续写或扩展实施例',
    [AIR_USAGE_UPGRADE_SHOW]: '免费版使用量超限弹窗展示',
    [TRACK_EVENT_SPECIFICATION_GENERATION_EXPORT]: '导出说明书',
    [TRACK_EVENT_SPECIFICATION_MODIFY_REGENERATE]: 'AI 助手重新生成内容',
    [TRACK_EVENT_SPECIFICATION_DISCLOSURE_UPLOAD]: '上传交底书',
    [TRACK_EVENT_SPECIFICATION_CLAIMS_UPLOAD]: '上传权利要求',
    [TRACK_EVENT_NOVELTY_CHECK_ENTER]: '进入查新功能',
    [TRACK_EVENT_NOVELTY_CHECK_USER_INPUT]: '填写查新输入',
    [TRACK_EVENT_NOVELTY_CHECK_UPLOAD_DOCUMENT]: '上传查新文档',
    [TRACK_EVENT_NOVELTY_CHECK_SELECT_EXAMPLE]: '选择查新样例',
    [TRACK_EVENT_NOVELTY_CHECK_LAUNCH]: '启动查新',
    [TRACK_EVENT_NOVELTY_CHECK_CLICK_MEMORY]: '点击查新记忆',
    [TRACK_EVENT_NOVELTY_CHECK_LAUNCH_ERROR]: '查新启动失败',
    [TRACK_EVENT_NOVELTY_CHECK_ABORT_TECH_FEATURE]: '取消技术特征识别',
    [TRACK_EVENT_NOVELTY_CHECK_CONFIRM_TECH_FEATURE]: '确认技术特征',
    [TRACK_EVENT_NOVELTY_CHECK_DEEP_THINKING_STOP]: '停止深度思考',
    [TRACK_EVENT_NOVELTY_CHECK_ADD_REF_PATENT]: '添加参考专利',
    [TRACK_EVENT_NOVELTY_CHECK_SAVE_TO_WORKSPACE]: '保存到工作区',
    [TRACK_EVENT_NOVELTY_CHECK_SAVE_TO_WORKSPACE_SUCCESS]: '成功保存到工作区',
    [TRACK_EVENT_NOVELTY_CHECK_COMPARE_TABLE_BACK]: '返回对比表',
    [TRACK_EVENT_NOVELTY_CHECK_VIEW_PATENT_DETAIL]: '查看专利详情',
    [TRACK_EVENT_NOVELTY_CHECK_SEARCH_COMMON_EVIDENCE]: '检索共同证据',
    [TRACK_EVENT_NOVELTY_CHECK_TOGGLE_COMMON_EVIDENCE]: '展开或收起共同证据',
    [TRACK_EVENT_NOVELTY_CHECK_SHOW_MORE_RESULTS]: '查看更多结果',
    [TRACK_EVENT_NOVELTY_CHECK_SEARCH_RESULT_SELECT]: '选择检索结果',
    [TRACK_EVENT_NOVELTY_CHECK_COMPARISON_LIST_EDIT]: '编辑对比列表',
    [TRACK_EVENT_NOVELTY_CHECK_CREATE_REPORT]: '生成查新报告',
    [TRACK_EVENT_NOVELTY_CHECK_REPORT_EXPAND]: '展开查新报告',
    [TRACK_EVENT_NOVELTY_CHECK_REPORT_EDIT_TECH_PROPOSAL]: '编辑查新技术方案',
    [TRACK_EVENT_NOVELTY_CHECK_REPORT_UNSELECT_FEATURE]: '取消选择技术特征',
    [TRACK_EVENT_NOVELTY_CHECK_REPORT_ADD_FEATURE]: '新增技术特征',
    [TRACK_EVENT_NOVELTY_CHECK_REPORT_UPDATE_RETRIEVAL_ELEMENTS]: '更新检索要素',
    [TRACK_EVENT_NOVELTY_CHECK_REPORT_FAMILY_GROUP]: '操作专利家族分组',
    [TRACK_EVENT_NOVELTY_CHECK_REPORT_SETTING_CHANGE]: '修改查新报告设置',
    [TRACK_EVENT_NOVELTY_CHECK_REPORT_EXPORT]: '导出查新报告',
    [TRACK_EVENT_NOVELTY_CHECK_REPORT_SELECT_OLD_VERSION]: '切换旧版查新',
    [TRACK_EVENT_NOVELTY_CHECK_REPORT_SELECT_NEW_VERSION]: '切换新版查新',
    [TRACK_EVENT_FTO_REPORT_ENTER]: '进入 FTO 报告',
    [TRACK_EVENT_FTO_REPORT_SET_ADVANCED_SETTINGS]: '设置 FTO 高级选项',
    [TRACK_EVENT_FTO_REPORT_USER_INPUT]: '填写 FTO 技术方案',
    [TRACK_EVENT_FTO_REPORT_SELECT_EXAMPLE]: '选择 FTO 样例',
    [TRACK_EVENT_FTO_REPORT_LAUNCH]: '启动 FTO Agent',
    [TRACK_EVENT_FTO_REPORT_INPUT_SUBMIT]: '提交 FTO 输入',
    [TRACK_EVENT_FTO_REPORT_ABORT_TECH_FEATURE]: '取消 FTO 技术特征识别',
    [TRACK_EVENT_FTO_REPORT_EDIT_TECH_FEATURE]: '编辑 FTO 技术特征',
    [TRACK_EVENT_FTO_REPORT_DEEP_THINKING_STOP]: '停止 FTO 深度思考',
    [TRACK_EVENT_FTO_REPORT_VIEW_TECH_COMPARE]: '查看技术对比',
    [TRACK_EVENT_FTO_REPORT_ADD_PATENT]: '添加专利',
    [TRACK_EVENT_FTO_REPORT_ADD_REF_PATENT]: '添加参考专利',
    [TRACK_EVENT_FTO_REPORT_EDIT_FEATURE_TABLE]: '编辑特征对比表',
    [TRACK_EVENT_FTO_REPORT_VIEW_PATENT_DETAIL]: '查看 FTO 专利详情',
    [TRACK_EVENT_FTO_REPORT_SHOW_MORE_RESULTS]: '查看更多 FTO 结果',
    [TRACK_EVENT_FTO_REPORT_SEARCH_RESULT_SELECT]: '选择 FTO 检索结果',
    [TRACK_EVENT_FTO_REPORT_CREATE_REPORT]: '生成 FTO 报告',
    [TRACK_EVENT_FTO_REPORT_REPORT_EXPAND]: '展开 FTO 报告',
    [TRACK_EVENT_FTO_REPORT_REPORT_EXPORT]: '导出 FTO 报告',
    [TRACK_EVENT_FTO_REPORT_CREATE_NEW_TASK]: '创建新的 FTO 任务',
    [TRACK_EVENT_FTO_REPORT_PROPOSAL_GENERATED]: '生成 FTO 技术方案',
    [TRACK_EVENT_FTO_REPORT_FEATURE_CONFIRM_ACTION]: '确认特征操作',
    [TRACK_EVENT_FTO_REPORT_FEATURE_EDIT_ACTION]: '编辑特征操作',
    [TRACK_EVENT_FTO_REPORT_CONFIRM_RUN]: '确认运行 FTO 检索',
    [TRACK_EVENT_FTO_REPORT_EDIT_SAVE]: '保存 FTO 编辑',
    [TRACK_EVENT_FTO_REPORT_PATENT_RECLASSIFY]: '重新分类专利',
    [TRACK_EVENT_FTO_REPORT_EDIT]: '编辑 FTO 报告',
    [TRACK_EVENT_FTO_REPORT_IMPORT_FROM_WORKSPACE]: '从工作区导入专利',
    [TRACK_EVENT_HOMEPAGE_MORE_AGENTS_TOGGLE]: '展开或收起首页更多 Agent',
    [TRACK_EVENT_HOMEPAGE_MORE_AGENTS_CLICK]: '点击首页更多 Agent',
    [TRACK_EVENT_HOMEPAGE_WORK_IN_PROGRESS_CLICK]: '点击首页工作中任务模块',
    [TRACK_EVENT_PLANS_UPGRADE_PRO_CLICK]: '套餐页点击升级 Pro',
    [TRACK_EVENT_PLANS_CONTACT_SALES_CLICK]: '套餐页点击联系销售',
    [TRACK_EVENT_HUBSPOT_FORM_SUBMIT]: '提交 HubSpot 表单',
    [TRACK_EVENT_TASK_SHARE_MENU_CLICK]: '打开任务分享菜单',
    [TRACK_EVENT_TASK_SHARE_COPY_LINK_CLICK]: '复制任务分享链接',
    [TRACK_EVENT_DESIGN_FTO_ENTER]: '进入外观 FTO',
    [TRACK_EVENT_DESIGN_FTO_SELECT_EXAMPLE]: '选择外观 FTO 示例图片',
    [TRACK_EVENT_DESIGN_FTO_UPLOAD_IMAGE]: '上传外观 FTO 图片',
    [TRACK_EVENT_DESIGN_FTO_LAUNCH]: '启动外观 FTO',
    [TRACK_EVENT_DESIGN_FTO_ENTER_FLOW]: '进入外观 FTO 流程',
    [TRACK_EVENT_DESIGN_FTO_VIEW_PATENT_DETAIL]: '查看外观 FTO 专利详情',
    [TRACK_EVENT_DESIGN_FTO_VIEW_COMPARISON]: '查看外观 FTO 特征对比',
    [TRACK_EVENT_DESIGN_FTO_SHARE]: '分享外观 FTO 结果',
    [TRACK_EVENT_DESIGN_FTO_COPY_LINK]: '复制外观 FTO 分享链接',
    [TRACK_EVENT_DESIGN_FTO_EXPORT_REPORT]: '导出外观 FTO 报告',
    [TRACK_EVENT_UPGRADE_TRIGGER]: '触发升级',
    [TRACK_EVENT_REGISTER_EXPOSURE]: '展示登录注册弹窗',
    [TRACK_EVENT_REGISTER_CLICK]: '点击注册',
    [TRACK_EVENT_REGISTER_CLOSE]: '关闭注册弹窗',
    [TRACK_EVENT_PRICING_PAGE_VIEW]: '浏览定价页面',
    [TRACK_EVENT_CLICK_SUBSCRIBE_PRO]: '点击订阅 Pro',
    [TRACK_EVENT_CLICK_SUBSCRIBE_ENTERPRISE]: '点击订阅 Enterprise',
    [TRACK_EVENT_CLICK_SUBSCRIBE_API]: '点击订阅 API',
    [TRACK_EVENT_DESIGN_FTO_COPY_LINK_2]: '复制结果分享链接',
    [TRACK_EVENT_DESIGN_FTO_VIEW_RESULT]: '查看外观 FTO 步骤结果',
    [TRACK_EVENT_AGENT_REPORT_ACTIONS_SPOTLIGHTED]: '高亮 Agent 报告分享与导出入口',
    [SOURCE_TYPE.agent_home]: 'Agent 首页事件',
    [TRACK_EVENT_IP_AGENT_GUEST_REGISTER_WALL_SHOWN]: '展示游客注册墙',
    [TRACK_EVENT_IP_AGENT_GUEST_REGISTER_WALL_CLOSED]: '关闭游客注册墙',
    [TRACK_EVENT_IP_AGENT_GUEST_REGISTER_STARTED]: '游客进入注册流程',
    [TRACK_EVENT_IP_AGENT_GUEST_REGISTER_SUCCEEDED]: '游客注册完成并回到产品',
    [TRACK_EVENT_IP_AGENT_GUEST_PENDING_ACTION_RESUMED]: '游客注册后续操作续接成功',
    [TRACK_EVENT_GUEST_ACTION_RESUME_FAILED]: '游客后续操作续接失败',
};
